export default __webpack_public_path__ + "static/large-cabin-bedroom2-fb8dd62fe668b983f8d2c33e9bd9c87d.jpg";